import axios, {AxiosError, AxiosResponse} from 'axios';

const API_URL = "https://delivery-plus.a2hosted.com/api";

export default async function HttpRequest(url: string, method: any, data?: any) {

    return axios.request({
        url: url,
        baseURL: API_URL,
        method: method,
        data: data,
    }).then((result: AxiosResponse) => {
        return Promise.resolve(result);

    }).catch((err: AxiosError) => {
        // Callers inspect `.status` on the rejection value. On a transport failure
        // there is no response at all, so stand in a zero status rather than
        // rejecting with undefined.
        return Promise.reject(err.response ?? {status: 0, data: null});
    });
}
